// extracted by mini-css-extract-plugin
export default {"promo_wrapper":"l-","disabled":"m-","spinner":"n-","codes":"o-","item":"p-","remove":"q-","promo":"r-","apply":"s-"};
    if(module.hot) {
      // 1713996750348
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  